import { Grid } from '@material-ui/core';
import { Waypoint } from 'react-waypoint';
import { Loader } from 'components/Loader';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from 'redux/store';
import { PostsList } from '../PostsList';
import { getPaginatedPosts } from 'redux/thunks/team';

const AllTokens: React.FC = () => {
	const userState = useSelector((store: RootStore) => store.user);
	const teamState = useSelector((store: RootStore) => store.team);
	const dispatch = useDispatch();
	let postsListView;

	const getAdditionalPosts = () => {
		if (userState.selectedTeam) {
			dispatch(getPaginatedPosts(userState.selectedTeam?.teamId, 25, teamState.continuationToken));
		}
	};

	const reachedWaypoint = () => {
		getAdditionalPosts();
	};

	if (teamState.loading) {
		postsListView = (
			<div className='loader-wrapper'>
				<Loader />
			</div>
		);
	} else if (teamState.posts?.length > 0 && !teamState.loading) {
		postsListView = (
			<PostsList
				deletingPost={teamState.deletingPost}
				deletingSubpost={teamState.deletingSubpost}
				postsProp={teamState.posts}
				userId={userState.userId}
				subpostsLoading={teamState.subpostsLoading}
				currentTeam={userState.selectedTeam}
			/>
		);
	} else {
		postsListView = <div className='no-posts-message'>No tokens have been shared in this team. Send some today!</div>;
	}

	return (
		<>
			<Grid container direction='column' alignContent='center' alignItems='center'>
				{postsListView}
				{teamState.posts?.length > 0 && !teamState.allPostsLoaded ? <Waypoint onEnter={reachedWaypoint}></Waypoint> : <></>}
				{teamState.paginatedPostsLoading ? (
					<div className='loader-wrapper pagination-loader'>
						<Loader />
					</div>
				) : (
					<></>
				)}
			</Grid>
		</>
	);
};

export default AllTokens;
